import {Box, IconButton} from "@mui/material";
import React from "react";
import {Close, DragIndicator, Edit} from "@mui/icons-material";
import {RenderInputField} from "./ItemField";


export function renderTemplate(template, item) {
    const data = {item}
    // Function to get the value from the nested object using a path
    function getValueFromPath(obj, path) {
        return path.split('.').reduce((acc, part) => {
            // Handle array indexing
            const arrayMatch = part.match(/^([^\[]+)\[(\d+)\]$/);
            if (arrayMatch) {
                const arrayName = arrayMatch[1];
                const index = parseInt(arrayMatch[2], 10);
                return acc && acc[arrayName] && acc[arrayName][index];
            }
            return acc && acc[part];
        }, obj);
    }

    // Regular expression to match the placeholders in the template
    const regex = /\$\{([^}]+)\}/g;

    // Replace the placeholders with actual values from the body object
    return template.replace(regex, (match, path) => {
        const value = getValueFromPath(data, path.trim());
        return value !== undefined ? value : match;
    });
}

export const FieldWithActionButtons = ({attr, setEditAttribute, setAttributes, mt, index, InputComponent}) => {
    if (!attr) return null
    return (
        <Box key={index} mt={mt} display="flex" alignItems="center" >
            <DragIndicator style={{cursor: 'pointer', marginRight: '10px'}} />
            {InputComponent ? InputComponent : <RenderInputField attr={attr} disabled={true} fromType={true} />}

            <Box display="flex" flexDirection="column" ml={1}>
                {setEditAttribute && <IconButton edge="end" aria-label="edit"
                    sx={{ transform: 'scale(0.85)', padding: '4px'}}
                    onClick={() => {
                        setEditAttribute(attr)
                    }}
                    size="small"
                >
                    <Edit />
                </IconButton>}

                <IconButton edge="end" aria-label="delete"
                            sx={{ transform: 'scale(0.85)', padding: '4px'}}
                            onClick={() => {
                                setAttributes(prevAttrs => prevAttrs.filter(a => a.attrType !== attr.attrType))
                            }}
                            size="small"
                >
                    <Close />
                </IconButton>
            </Box>
        </Box>
    )
}

